import { connect } from "react-redux";
import { useAppService } from "../../hooks/use-app-service";
import { history } from "../../_config";
import I18 from "../atoms/i18";
import IconButton2 from "../icon-button-2-component";

function DirectMessageIcon({ user, community, chats }) {
  const { analyticsService } = useAppService();

  const unreadCount = chats.reduce((acc, value) => {
    if (value && value.unreadMessageCount !== undefined) {
      return acc + value.unreadMessageCount;
    }
  }, 0);

  return (
    <>
      {user && community && !community.isDirectMessageDisabled && (
        <div className="flex flex-row items-center px-1">
          <IconButton2
            icon="comment-alt"
            className="text-xl cursor-pointer"
            onClick={() => {
              analyticsService.track("dm-click-header");
              history.push("/direct-message/users");
            }}
            unreadCount={unreadCount}
          />
          <div className="sm:hidden">
            <I18>Direct message</I18>
          </div>
        </div>
      )}
    </>
  );
}

const stp = (state) => ({
  user: state.auth,
  community: state.community,
  chats: state.directMessages.users,
});

export default connect(stp)(DirectMessageIcon);
